// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19MUM","label":"styles_label__rA501"};